import $ from 'jquery';
/**
 * Enables the "validation" functionality.
 */
const enableValidationFunctionality = () => {
    if ($.validator) {
        // Adds client-side validation for "phonenumber" form control data attributes
        const PHONENUMBER = 'phonenumber';
        $.validator.addMethod(PHONENUMBER, function (value, _element, params) {
            if (value === '') {
                return true;
            }
            return (value.match(params[0]) !== null);
        });
        if ($.validator.unobtrusive) {
            $.validator.unobtrusive.adapters.add(PHONENUMBER, ['regex'], (options) => {
                options.rules.phonenumber = [options.params['regex']];
                if (options.message) {
                    options.messages.phonenumber = options.message;
                }
            });
        }
    }
};
export default enableValidationFunctionality;
